import KBaseMapInfoWindow from "@/components/Maps/KBaseMapInfoWindow";
import { Geocodable } from "kinnect-mixins";
import {
	VCard,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import {
	formatCardinalDirection,
	formatDate,
	formatDuration,
	formatTime
} from "kinnect-formatters";

export default {
	name: "KHistoryInfoWindow",

	props: { item: Object },

	mixins: [ Geocodable ],

	computed: {
		locationToGeocode() {
			return {
				lat: this.item.lat,
				lng: this.item.lng
			};
		},

		locationName() {
			if ( this.geocoderRunning ) {
				return "Loading...";
			} else if ( this.geocodedLocation ) {
				return this.geocodedLocation.name;
			}
		},

		genDateTime() {
			const formattedDate = formatDate( this.item.date );
			const formattedTime = formatTime( this.item.date );
			let dateTimeStr = `${formattedDate} ${formattedTime}`;

			if ( this.item.endDate ) {
				const formattedEndTime = formatTime( this.item.endDate );

				if ( formattedTime !== formattedEndTime ) {
					dateTimeStr += ` - ${formattedEndTime} (${formatDuration( this.item.endDate - this.item.date, false, false )})`;
				}
			}

			return dateTimeStr;
		}
	},

	mounted() {
		this.geocode();
	},

	render() {
		return <KBaseMapInfoWindow offsetY={-10} showPano>
			<VCard flat light>
				<VList class="list--auto-height" dense>
					<VListItem>
						<VListItemAction>
							<VIcon>place</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								{this.genDateTime}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>

					<VListItem>
						<VListItemAction>
							<VIcon>explore</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								{this.item.speed
									? ` ${this.item.speed} mph ${formatCardinalDirection( this.item.direction )}`
									: " Stopped"
								}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>

					<VListItem>
						<VListItemAction>
							<VIcon>place</VIcon>
						</VListItemAction>

						<VListItemContent>
							<VListItemTitle>
								{this.locationName}
							</VListItemTitle>
						</VListItemContent>
					</VListItem>
				</VList>
			</VCard>
		</KBaseMapInfoWindow>;
	}
};
